// src/router/facility-account/index.js
import { ROLES } from "@/constants";
export default [
  {
    path: "setting/facility-account", // => /admin/setting/facility-account
    name: "accounts",
    meta: {
      title: "List Accounts",
      authRequired: true,
      roles: [ROLES.FACILITY_MANAGER, ROLES.FACILITY_ACCOUNT],
    },
    component: () => import('@/views/account/list-account/index.vue'),
  },
  {
    path: "setting/facility-account/create", // => /admin/setting/facility-account/create
    name: "create-account",
    meta: {
      title: "Create Account",
      authRequired: true,
      roles: [ROLES.FACILITY_MANAGER],
    },
    component: () => import('@/views/account/create-edit-account/index.vue'),
  },
  {
    path: "setting/facility-account/edit/:id", // => /admin/setting/facility-account/edit/:id
    name: "edit-account",
    meta: {
      title: "Edit Account",
      authRequired: true,
      roles: [ROLES.FACILITY_MANAGER],
    },
    component: () => import('@/views/account/create-edit-account/index.vue'),
  },
];
